import script from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AuthenticatedLayout.vue?vue&type=style&index=0&id=26c9ba18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c9ba18"]])

export default __exports__